if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // Prevent the ModalDialog pointerup-to-close handler from firing on nav/thumb buttons
        this.querySelectorAll('.product-media-modal__nav, .product-media-modal__thumb').forEach((el) => {
          el.addEventListener('pointerup', (e) => e.stopPropagation());
        });

        this.querySelector('.product-media-modal__nav--prev')
          ?.addEventListener('click', () => this.navigate(-1));
        this.querySelector('.product-media-modal__nav--next')
          ?.addEventListener('click', () => this.navigate(1));
        this.querySelectorAll('.product-media-modal__thumb').forEach((thumb) => {
          thumb.addEventListener('click', () => this.showMediaById(thumb.dataset.mediaId));
        });
        this.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowLeft') this.navigate(-1);
          if (e.key === 'ArrowRight') this.navigate(1);
        });
      }

      mediaItems() {
        return [...this.querySelectorAll('.product-media-modal__content [data-media-id]')];
      }

      navigate(dir) {
        const items = this.mediaItems();
        if (items.length < 2) return;
        const active = this.querySelector('.product-media-modal__content [data-media-id].active');
        const idx = active ? items.indexOf(active) : 0;
        const next = items[(idx + dir + items.length) % items.length];
        this.showMediaById(next.dataset.mediaId);
      }

      showMediaById(mediaId) {
        this.mediaItems().forEach((el) => el.classList.remove('active'));
        const target = this.querySelector(`.product-media-modal__content [data-media-id="${mediaId}"]`);
        if (!target) return;
        target.classList.add('active');

        if (target.nodeName === 'DEFERRED-MEDIA') {
          const tmpl = target.querySelector('template');
          if (tmpl?.content?.querySelector('.js-youtube')) target.loadContent();
        }

        this.querySelectorAll('.product-media-modal__thumb').forEach((t) => {
          t.classList.toggle('active', t.dataset.mediaId === mediaId);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.showMediaById(mediaId);
      }
    }
  );
}
